module.exports = {
    website_name : "Oasis Arena", // website name
    domain : "https://oasisarena.pro", // website host domain
    api_server: "https://oasisarena.cyclic.app",  // for production
    // api_server: "http://localhost:5000",  // for local testing
    discord_url :"https://discord.gg/kcrmXPZrT6", // for discord invite
    next_tournament : "Dec 20, 2023 20:00:00", // date and time for next tournament in IST
}